<!--
  单笔转账
  lovi 2020-06-22
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      class="gradient"
      :title="$t('transfer.singleTransfer')"
      :fixed="true"
      left-arrow
      @click-left="navBarBack"
    />
    <div class="scroll-wrapper">
      <div class="bg"></div>
      <scroll ref="scroll">
        <div class="column select-amount">
          <div class="transfer-info">
            <div class="head-img">
              <img
                class="icon"
                :src="
                  data.avatar
                    ? httpUrl + data.avatar
                    : require('@/assets/images/public/logo@2x.png')
                "
              />
            </div>
            <p class="info-type">{{ $t("transfer.transferPersonal") }}</p>
            <div class="info-item">
              <span class="text-gray">{{ data.username }}</span>
              <span class="text-blue"> ({{ _phoneDispose(data.phone) }}) </span>
            </div>
          </div>
          <van-field
            class="van-field-input"
            v-model="money"
            type="number"
            :formatter="_formatter"
            :placeholder="$t('common.enterAmount')"
            clearable
          >
            <span slot="right-icon">P</span>
          </van-field>
          <van-field
            v-model="remark"
            class="van-field-remark"
            :placeholder="$t('transfer.addNote20')"
            :maxlength="20"
          />
        </div>
        <div class="button-wrap">
          <van-button block type="primary" @click="submit">
            {{ $t("transfer.confirmTransfer") }}
          </van-button>
        </div>
      </scroll>
    </div>

    <enter-payPsd
      :payPsdFlag.sync="payPsdFlag"
      :data="payPsdData"
      @getPayPsd="transferAjax"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EnterPayPsd from "@/components/enterPayPsd";
export default {
  props: {
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  components: {
    EnterPayPsd
  },
  data() {
    return {
      money: "",
      remark: "",
      payPsdFlag: false,
      payPsdData: {
        title: this.$t("transfer.transferAmount"),
        money: ""
      }
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    navBarBack() {
      // 返回事件
      this.$emit("update:amountFlag", false);
    },
    submit() {
      //确认转账
      let vm = this;
      //判断余额够不够
      vm.money = vm.money ? Number(vm.money).toFixed(2) : "";
      if (vm.money == "" || vm.money == 0) {
        vm.$toast(vm.$t("common.enterAmount"));
        return;
      }
      if (vm.money < 0) {
        vm.$toast(vm.$t("common.enterCorrectAmount"));
        return;
      }
      if (Number(vm.money) > Number(vm.userInfo.money_usable)) {
        vm.$dialog
          .confirm({
            message: vm.$t("common.balanceInsufficientRecharge"),
            confirmButtonText: vm.$t("common.rechargeNow"),
            cancelButtonText: vm.$t("common.cancel")
          })
          .then(() => {
            // on confirm
            vm.$router.push({
              path: "/recharge"
            });
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      vm.payPsdData.money = vm.money;
      vm.payPsdFlag = true;
    },
    transferAjax(data) {
      let vm = this;
      let params = {};
      params.username = vm.data.username;
      params.phone = vm.data.phone;
      params.money = vm.money;
      params.remark = vm.remark;
      params.pay_password = data;
      vm.$post("/app/transfer/transferUser", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("transferUser", res);
        if (res.code == 0) {
          vm.$store.dispatch("GET_USER_INFO");
          vm.$router.push({
            path: "/detail",
            name: "detail",
            query: { flag: 3, order_id: res.data.order_id }
          });
          vm.remark = "";
          vm.money = "";
        } else {
          vm.$toast(res.msg);
        }
      });
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.scroll-wrapper {
  background: #f4f4f4;
  .bg {
    height: 50px;
    background: linear-gradient(90deg, #2043ac, #130f73);
  }
}
.transfer-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 20px 0;
  .head-img {
    width: 92px;
    height: 92px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info-type {
    font-size: 14px;
    color: #4a4a4a;
    margin: 4px 0;
  }
  .info-item {
    span + span {
      margin-left: 5px;
    }
  }
}
.column {
  &.select-amount {
    padding: 15px;

    .title {
      padding: 0;
    }
  }

  .van-field-input {
    margin: 12px 0;
  }
  .van-field-remark {
    padding: 0;
    margin: 6px 0;
  }
}
</style>
